import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const badweather = document.getElementById("sick_note_bad_weather")
    const wholeday = document.getElementById("sick_note_whole_day")
    const wholeDayContainer = document.getElementsByClassName("whole_day")[0]
    const badWeatherHoursContainer = document.getElementsByClassName(
      "sick_note_bad_weather_hours",
    )[0]

    if (!badweather || !wholeday || !wholeDayContainer || !badWeatherHoursContainer) {
      return
    }

    if (badweather.checked) {
      if (wholeday.checked) {
        badWeatherHoursContainer.style.display = "none"
      }
    } else {
      wholeDayContainer.style.display = "none"
      badWeatherHoursContainer.style.display = "none"
    }
  }

  showwholeday() {
    const ele = document.getElementById("sick_note_bad_weather")
    const wholeDayContainer = document.getElementsByClassName("whole_day")[0]
    const badWeatherHoursContainer = document.getElementsByClassName(
      "sick_note_bad_weather_hours",
    )[0]
    const wholeDayCheckbox = document.getElementById("sick_note_whole_day")

    if (!ele || !wholeDayContainer || !badWeatherHoursContainer) {
      return
    }

    if (ele.checked) {
      wholeDayContainer.style.display = ""
      badWeatherHoursContainer.style.display = ""
    } else {
      wholeDayContainer.style.display = "none"
      badWeatherHoursContainer.style.display = "none"
      if (wholeDayCheckbox) {
        wholeDayCheckbox.checked = false
      }
    }
  }

  hideweatherhours() {
    const ele = document.getElementById("sick_note_whole_day")
    const badWeatherHoursContainer = document.getElementsByClassName(
      "sick_note_bad_weather_hours",
    )[0]

    if (!ele || !badWeatherHoursContainer) {
      return
    }

    if (ele.checked) {
      badWeatherHoursContainer.style.display = "none"
    } else {
      badWeatherHoursContainer.style.display = ""
    }
  }
}
